export default __webpack_public_path__ + "static/media/snapchat.8e6fcdd0.svg";